import React from "react";
import { Link } from "gatsby";
import config from "../../data/SiteConfig";

/* eslint-disable */
const Topbar = class extends React.Component {
  renderNav(locale) {
    const Menu = config.topMenu;
    switch (locale) {
      case "tr":
        return (
          Menu &&
          Menu.map((data) => {
            return (
              <li key={data.tr}>
                <Link
                  className="navbar-item"
                  to={`/tr${data.url}`}
                  activeClassName="active"
                  title={data.tr}
                >
                  {data.tr}
                </Link>
              </li>
            );
          })
        );
        case "de":
          return (
            Menu &&
            Menu.map((data) => {
              return (
                <li key={data.de}>
                  <Link
                    className="navbar-item"
                    to={`/de${data.url}`}
                    activeClassName="active"
                    title={data.de}
                  >
                    {data.de}
                  </Link>
                </li>
              );
            })
          );
      default:
        return (
          Menu &&
          Menu.map((data) => {
            return (
              <li key={data.en}>
                <Link
                  className="navbar-item"
                  to={data.url}
                  activeClassName="active"
                  title={data.en}
                >
                  {data.en}
                </Link>
              </li>
            );
          })
        );
    }
  }

  render() {
    const locale = this.props.locale;
    return (
      <nav>
        <ul>{this.renderNav(locale)}</ul>
      </nav>
    );
  }
};

export default Topbar;
